require('../../modules/es.array.iterator');
require('../../modules/es.object.to-string');
require('../../modules/es.weak-set');
var path = require('../../internals/path');

module.exports = path.WeakSet;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/weak-set/index.js
// module id = 529
// module chunks = 49